import { render } from "./DropDown.vue?vue&type=template&id=5f5a59ae&ts=true"
import script from "./DropDown.vue?vue&type=script&lang=ts"
export * from "./DropDown.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__